import {
  Component,
  Input,
  AfterContentChecked,
  ViewChild,
  ElementRef,
} from "@angular/core";
import { trimTextByWord } from "../../admin/events-screen/utils/trimTextByWord";

@Component({
  selector: "legacy-text-trimmer-popover",
  template: `<div style="display:none;" #contentWrapper>
      <ng-content></ng-content>
    </div>
    <span
      *ngIf="trimText(textElement, maxLength) !== textElement"
      [tooltip]="textElement"
      placement="top"
    >
      {{ trimText(textElement, maxLength) }}
    </span>
    <span *ngIf="trimText(textElement, maxLength) === textElement">
      {{ trimText(textElement, maxLength) }}
    </span> `,
})
export class LegacyTextTrimPopoverComponent implements AfterContentChecked {
  @Input() public maxLength: number;
  public textElement: string = "";

  @ViewChild("contentWrapper")
  public contentWrapper: ElementRef;

  constructor() {}
  public ngAfterContentChecked() {
    const text = this.contentWrapper.nativeElement.innerText;
    if (text !== this.textElement) {
      this.textElement = text;
    }
  }

  public trimText(text: string, maxlength = 14) {
    return trimTextByWord(text, maxlength);
  }
}



// WEBPACK FOOTER //
// ./src/app/common/text-trim-popover/legacy-text-trim-popover.component.ts